import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface PaginatedResponse<T> {
  data: T[];
  pagination?: { page: number; pageSize: number; total: number; totalPages: number };
}

export function useList<T>(path: string, params: Record<string, unknown> = {}) {
  return useQuery({
    queryKey: [path, params],
    queryFn: async () => {
      const { data } = await api.get<PaginatedResponse<T>>(path, { params });
      return data;
    },
  });
}
